<template>
  <v-container fluid>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      class="align-center d-flex justify-center mx-auto my-4"
    ></v-progress-circular>
    <v-alert
      v-else
      id="tempo-estimado-conciliacao-container"
      class="display-1"
      transition="scale-transition"
      :icon="tempoEstimado ? 'mdi-clock-outline' : 'mdi-alert-outline'"
      :color="tempoEstimado ? 'primary' : 'error'"
      dark
    >
      <div v-if="tempoEstimado">
        Com base nos parâmetros definidos, o tempo
        <strong class="text-uppercase">estimado</strong>
        para o processamento desta conciliação é de aproximadamente:
        <div class="display-2 font-weight-bold my-3 text-center">{{ tempoEstimado }}</div>
      </div>
      <div v-else>Não foi possível obter a estimativa de tempo para esta conciliação.</div>
    </v-alert>
  </v-container>
</template>

<script>
  export default {
    name: 'TempoEstimadoConciliacaoAlert',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      tempoEstimado: {
        type: String,
        default: null
      }
    }
  };
</script>